import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";
import { ChevronDown, ChevronUp } from "lucide-react";

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-6);
  color: var(--color-text-primary);
`;

const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;

const FAQItem = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
`;

const Question = styled.button<{ $isOpen: boolean }>`
  width: 100%;
  text-align: left;
  padding: var(--spacing-4);
  background: none;
  border: none;
  color: var(--color-text-primary);
  font-size: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const Answer = styled.div<{ $isOpen: boolean }>`
  padding: ${(props) => (props.$isOpen ? "var(--spacing-4)" : "0")};
  padding-top: ${(props) => (props.$isOpen ? "0" : "0")};
  max-height: ${(props) => (props.$isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: all 0.3s ease;
  color: var(--color-text-secondary);
  line-height: 1.6;
`;

const FAQ = () => {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);

  const faqItems = [
    {
      question: "Comment puis-je créer un compte ?",
      answer:
        "Pour créer un compte, cliquez sur le bouton 'Connexion' en haut à droite, puis sélectionnez 'Créer un compte'. Remplissez le formulaire avec vos informations et suivez les instructions.",
    },
    {
      question: "Comment ajouter un film à ma liste ?",
      answer:
        "Pour ajouter un film à votre liste, cliquez sur l'icône de cœur à côté du film. Vous pouvez retrouver tous vos films enregistrés dans la section 'Ma Liste'.",
    },
    {
      question: "Comment fonctionne la recherche ?",
      answer:
        "Utilisez la barre de recherche en haut de la page pour trouver des films et séries. Vous pouvez rechercher par titre, acteur ou genre.",
    },
    {
      question: "Les informations sont-elles mises à jour régulièrement ?",
      answer:
        "Oui, notre base de données est mise à jour quotidiennement avec les dernières informations sur les films et séries.",
    },
    {
      question: "Comment signaler un problème ?",
      answer:
        "Si vous rencontrez un problème, vous pouvez nous contacter via la page Contact ou envoyer un email directement à ytbrelaxmusic@gmail.com.",
    },
  ];

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Layout>
      <FAQContainer>
        <Title>Questions Fréquentes</Title>
        <FAQList>
          {faqItems.map((item, index) => (
            <FAQItem key={index}>
              <Question
                onClick={() => toggleQuestion(index)}
                $isOpen={openIndex === index}
              >
                {item.question}
                {openIndex === index ? (
                  <ChevronUp size={20} />
                ) : (
                  <ChevronDown size={20} />
                )}
              </Question>
              <Answer $isOpen={openIndex === index}>{item.answer}</Answer>
            </FAQItem>
          ))}
        </FAQList>
      </FAQContainer>
    </Layout>
  );
};

export default FAQ;
